import { render, staticRenderFns } from "./zone-select-virtual.vue?vue&type=template&id=1b876433&scoped=true&"
import script from "./zone-select-virtual.vue?vue&type=script&lang=ts&"
export * from "./zone-select-virtual.vue?vue&type=script&lang=ts&"
import style0 from "./zone-select-virtual.vue?vue&type=style&index=0&id=1b876433&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b876433",
  null
  
)

export default component.exports